import { useQuery } from '@tanstack/react-query';
import { getProductById } from '@util/firestore/products';

export const useProduct = (productId: string) => {
  const data = useQuery({
    queryKey: ['product', productId],
    queryFn: () => getProductById(productId),
    enabled: !!productId,
  });
  return {
    data,
  };
};
